import {
    FETCH_ORGANIZATION_SETTINGS_START,
    FETCH_ORGANIZATION_SETTINGS_SUCCESS,
    FETCH_ORGANIZATION_SETTINGS_FAIL

} from "../../../constants";
import {
    GET_ORGANIZATION_DATA,
} from "../../../../../config/constants";
import { ApiBase } from "../../../../utils/apiBase";
import { withType } from "../../../../utils/actionOperations";
import { getProjectIdAndOrgId } from '../../../../utils/apiUtils';
import { SETTINGS_PAGE_SECTION } from "../../../../../config/tabConstants";

export const fetchOrganizationDataConfigurations = (payload, cb) => {
    const apiBaseInstance = new ApiBase().instance;
    return (dispatch) => {
        dispatch(
            withType(FETCH_ORGANIZATION_SETTINGS_START, { ...payload })
        );
        return apiBaseInstance
            .post(GET_ORGANIZATION_DATA, {
                ...payload, ...getProjectIdAndOrgId(payload),currentTab: SETTINGS_PAGE_SECTION.SETTINGS_SUB_TABS.ADMINISTRATOR
            })
            .then((res) => {
                dispatch(
                    withType(FETCH_ORGANIZATION_SETTINGS_SUCCESS, {
                        data: res.data,
                        payload: payload
                    })
                );
                cb && cb(res.data)
            })
            .catch((err) => {
                dispatch(withType(FETCH_ORGANIZATION_SETTINGS_FAIL, { ...err, ...payload }));
                cb && cb()
            });
    };
};

